import React, {useState} from 'react'

const AdminSites = ({ setShowAddSite }) => {

    const [formData, setFormData] = useState({
        site_name: '',
        site_location: '',
        site_image: null
    })


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };
    
      const handleFileChange = (e) => {
        setFormData((prevData) => ({
          ...prevData,
          site_image: e.target.files[0], // Store the selected file
        }));
      };

      const handleAddSite = async (e) => {
        e.preventDefault();

        const form = new FormData();
        for(let key in formData){
            form.append(key, formData[key]);
        }

        try{
            const response = await fetch('http://localhost:3002/api/add-site', {
                method: "POST",
                body: form,
            });
            if(response.ok){
                alert("Site Listed Successfully");
                setShowAddSite(false);
                window.location.reload();
            } else {
                alert("Failed to list site. Try again later.")
            }
        }
        catch(error){
            console.error("Error:", error);
        }
      };
      
      
    return (
        <>
            <section className='profile-area' onClick={() => setShowAddSite(false)}>
                <div className='profile-area-inner' onClick={(e) => e.stopPropagation()}>
                    <i className="fa-solid fa-clipboard profile-icon"></i><br />
                    <p className='fw-bold my-3'>Add New Site</p>


                    <form className="row g-3 mt-4" onSubmit={handleAddSite}>
                        <div className="col-12">
                            <input type="text" className="form-input" name='site_name' value={formData.site_name} onChange={handleChange} placeholder="Site Name" required />
                        </div>
                        <div className="col-12">
                            <input type="text" className="form-input" name='site_location' value={formData.site_location} onChange={handleChange} placeholder='Site Location' required />
                        </div>
                        <div className='col-12 text-start'>
                            <label for="Site Image" className='form-label text-muted' >Upload Site Image</label>
                            <input type="file"  class="form-input" name='site_image' onChange={handleFileChange} required />
                        </div>

                        <div className="col-12 my-4">
                            <button type="submit" className="admin-btn py-3 rounded w-100">List Site</button>
                        </div>
                    </form>
                    {/* form ends */}

                </div>
            </section>
        </>
    )
}

export default AdminSites
